import { render, staticRenderFns } from "./ReviewOrderViewSideDrawer.vue?vue&type=template&id=ee0c6974&scoped=true"
import script from "./ReviewOrderViewSideDrawer.ts?vue&type=script&lang=ts&external"
export * from "./ReviewOrderViewSideDrawer.ts?vue&type=script&lang=ts&external"
import style0 from "./ReviewOrderViewSideDrawer.vue?vue&type=style&index=0&id=ee0c6974&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0c6974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee0c6974')) {
      api.createRecord('ee0c6974', component.options)
    } else {
      api.reload('ee0c6974', component.options)
    }
    module.hot.accept("./ReviewOrderViewSideDrawer.vue?vue&type=template&id=ee0c6974&scoped=true", function () {
      api.rerender('ee0c6974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/SideDrawers/ReviewOrderViewSideDrawer.vue"
export default component.exports